import React from 'react'
import { MarketStatus } from '../../services/trading-service'

const LABEL: Record<MarketStatus['status'], string> = {
  open: 'Market open',
  pre_market: 'Pre-market',
  after_hours: 'After hours',
  closed: 'Market closed',
}

/** "Tue 9:30 AM ET" */
export const easternTime = (iso: string) =>
  `${new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    weekday: 'short',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(iso))} ET`

/** "9:03 AM ET" */
export const easternClock = (iso: string) =>
  `${new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(iso))} ET`

/** Open / pre-market / after hours / closed, with when it next opens or closes. */
const MarketStatusBadge = ({ market }: { market: MarketStatus | null }) => {
  if (!market) return null
  const next = market.isOpen
    ? market.nextClose && `Closes ${easternTime(market.nextClose)}`
    : market.nextOpen && `Opens ${easternTime(market.nextOpen)}`
  return (
    <span className={`trading-page__market is-${market.status}`} data-testid='market-status'>
      <i aria-hidden='true' />
      {LABEL[market.status]}
      {next ? <small> · {next}</small> : null}
    </span>
  )
}

export { MarketStatusBadge }
